if (!customElements.get('cart-shipping-status')) {
  customElements.define('cart-shipping-status', class extends HTMLElement {
    connectedCallback() {
      this.onCartChange = this.onCartChange.bind(this);
      document.addEventListener('cart:change', this.onCartChange);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this.onCartChange);
    }

    onCartChange(event) {
      if (this.dataset.mode !== 'threshold') return;

      const cart = event.detail.cart;
      const itemTotal = cart.items
        .filter((item) => item.requires_shipping)
        .reduce((sum, item) => sum + item.final_line_price, 0);
      const discountTotal = cart.cart_level_discount_applications
        .reduce((sum, item) => sum + item.discount_application.total_allocated_amount, 0);

      this.update(Math.max(itemTotal - discountTotal, 0));
    }

    update(total) {
      const threshold = Number(this.dataset.threshold);
      if (!threshold) return;

      const remaining = Math.max(threshold - total, 0);
      const complete = remaining === 0;
      const formatter = new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active
      });

      this.classList.toggle('is-complete', complete);
      this.querySelector('[data-shipping-message]').innerHTML = complete
        ? "YOU'VE UNLOCKED FREE SHIPPING"
        : `SPEND <strong>${formatter.format(remaining / 100)}</strong> MORE FOR FREE SHIPPING`;
      this.querySelector('[data-shipping-progress]').style.width = `${Math.min((total / threshold) * 100, 100)}%`;
    }
  });
}
